(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ConfirmationFlightEdit',
	};

	// Main form element
	var $form = $('form[name=ConfirmationFlightEdit]');

	// Serialized form data


	$(document)
	.ready(
		function documentReady() {
			Adzuki.Form.registerForm(form);
		}
	);

	form.load = function load()
	{
		var flightLists   = $form.find('.flight-list');
		var departureList = $form.find('#departure-flight-list');
		var returnList    = $form.find('#return-flight-list');

		dragula(
				[
					document.querySelector('#departure-flight-list'),
					document.querySelector('#return-flight-list')
				]
			)
			.on(
				'drop',
				function setValues(el, target, source, sibling) {
					setEmptyLists();
					setFlightOrder();
					setFlightType();
				}
			)
		;

		function setEmptyLists()
		{
			$(flightLists)
				.each(
					function setClass(i, el) {
						if ($(el).children().length > 0) {
							$(el).removeClass('empty');
						} else {
							$(el).addClass('empty');
						}
					}
				)
			;
		}

		function setFlightOrder()
		{
			$(flightLists)
				.each(
					function getFlightElements(i, el) {
						var flights = $(el).children();
						$(flights)
							.each(
								function setOrder(i, el) {
									$(el).find('.flight-order').val(i);
								}
							)
						;
					}
				)
			;
		}

		function setFlightType()
		{
			$(departureList).find('.flight-type').val('departure');
			$(returnList).find('.flight-type').val('return');
		}


	};


}(jQuery, window.Adzuki || {}));
